import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "heading-title" }, "Enter Verification Code", -1)
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "email-text" }
const _hoisted_5 = { class: "form-group mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Code", -1)
const _hoisted_7 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_8 = { class: "form-group mt-4" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "timing-color float-right" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.isFormInvalid)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "alert alert-danger",
          innerHTML: _ctx.validationMsg
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.isResponseValid)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: "v-code-text",
          innerHTML: _ctx.otpResponseMessage
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.getMaskedEmailAddress()), 1),
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: _normalizeClass(["form-control type-number", _ctx.v$.verificationCode.$error ? 'is-invalid' : 'input-text']),
          id: "name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.verificationCode) = $event)),
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.verificationCode.$touch()))
        }, null, 34), [
          [_vModelText, _ctx.verificationCode]
        ]),
        (_ctx.v$.verificationCode.$error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.v$.verificationCode.required)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass({ 'is-invalid': _ctx.v$.verificationCode.$error })
                  }, " Enter correct verification code ", 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "submit",
          disabled: _ctx.v$.verificationCode.$invalid || _ctx.isSubmitDisabled,
          class: _normalizeClass(["btn w-100", [_ctx.buttonDesign()]]),
          id: "button-continue",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.otpVerification && _ctx.otpVerification(...args)))
        }, " VERIFY ", 10, _hoisted_9)
      ])
    ], 32),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["float-left resend-code btn btn-link", [_ctx.resendTextEnable]]),
        id: "resend-button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resendCode()))
      }, " RESEND CODE ", 2),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatedCountdown), 1)
    ]),
    _hoisted_12
  ]))
}